import { render, staticRenderFns } from "./importStudents.vue?vue&type=template&id=6d657439&scoped=true&"
import script from "./importStudents.vue?vue&type=script&lang=js&"
export * from "./importStudents.vue?vue&type=script&lang=js&"
import style0 from "./importStudents.vue?vue&type=style&index=0&id=6d657439&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d657439",
  null
  
)

export default component.exports